import { useCallback, useEffect, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

import { BlogPost, AreaBlogResponse as Response } from './useArticleTemplate'

interface ArticleState {
  articles: BlogPost[]
  page: number
  count: number
  hasMore: boolean
  loading: boolean
  loadingMore: boolean
}

export const useWhoArticle = () => {
  const [state, setState] = useState<ArticleState>({
    articles: [],
    page: 1,
    count: 0,
    hasMore: true,
    loading: false,
    loadingMore: false,
  })

  const loadWhoArticles = useCallback(
    (isTemplate = false, pageSize = 3, isLoadMore = false) => {
      const loadMore = (!state.hasMore || state.loadingMore) && isLoadMore
      if (loadMore) return
      const nextPage = isLoadMore ? state.page + 1 : 1
      setState((prev) => ({
        ...prev,
        ...(isLoadMore ? { loadingMore: true } : { loading: true }),
      }))

      _data
        .get(
          `${Project.liveApi}website/who-we-are/blogs/?is_template=${isTemplate}&page=${nextPage}&page_size=${pageSize}`,
        )
        .then((data: Response) => {
          setState((prev) => ({
            ...prev,
            articles: isLoadMore
              ? [...prev.articles, ...data.results]
              : data.results,
            page: nextPage,
            hasMore: !!data.next,
            loadingMore: false,
            count: data.count,
          }))
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          setState((prev) => ({
            ...prev,
            ...(isLoadMore ? { loadingMore: false } : { loading: false }),
          }))
        })
    },
    [state.page, state.hasMore, state.loadingMore],
  )

  useEffect(() => {
    loadWhoArticles()
  }, [])

  return {
    isLoading: state.loading,
    isLoadingMore: state.loadingMore,
    hasMoreWhoArticles: state.hasMore,
    whoArticles: state.articles,
    articlesCount: state.count,
    loadWhoArticles,
  }
}
